import { NgModule } from '@angular/core';
import { NotFoundComponent } from './not-found/not-found.component';

@NgModule({
    declarations: [NotFoundComponent],
    exports: [NotFoundComponent],
})
export class ErrorModule {}
